// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","PaginationWrapper":"_1a-g-m","Pagination":"qFxfbq","PaginationContent":"_2CZapx","fadeInFrames":"bgSWBG"};